/**
 * @lighOutIntent 安卓站外跳转的path
 * @iosUniversalLink ios站外跳转的 link
 */
export const baseConfig = {
  scheme: 'light://',
  lighOutIntent: 'light_out_intent',
  iosUniversalLink: 'https://entertainment.dji.com/outsideH5',
  pasteboardLink: 'https://entertainment.dji.com/pasteboard',
  ios: (params) => {
    // ios端app底层交互方法
    const webkitObj = window.webkit;
    const jsHandlerFlag = webkitObj &&
                          webkitObj.messageHandlers &&
                          webkitObj.messageHandlers.jsToNative;
    if (jsHandlerFlag) {
      webkitObj.messageHandlers.jsToNative.postMessage(params);
    }
  },
  android: (params) => {
    // android端app底层交互方法
    if (window.knJSBridge) {
      window.knJSBridge.jsToNative(params);
    }
  },
};

export default {};
